<template>
  <div class="add">
    <div class="add-center">
      <!-- 头部 -->
      <header style="display: flex; align-items: center">
        <a-icon class="btn_back" theme="twoTone" type="left-circle" @click="$router.go(-1)" />
        <p>{{ gettypefunname }}</p>
        <!-- <a-icon type="left-circle" style="font-size: 20px; margin-left: 10px" @click="$router.go(-1)" /> -->
      </header>
      <aside>
        <div class="main">
          <div class="main-form">
            <a-form-model ref="ruleForm" :label-col="labelCol" :model="form" :rules="rules" :wrapper-col="wrapperCol" labelAlign="left">
              <h2>核心信息</h2>
              <a-button v-if="addBtnShow" class="addInfor" type="primary" @click="addClick">添加联系人信息</a-button>
              <!--最多只能有三个-->
              <a-row v-for="(item, index) in form.lessorInfoBoList" :key="index">
                <a-col :span="4">
                  <a-form-model-item ref="lessorsName" :required="true" label="联系人">
                    <a-input v-model="item.lessorsName" style="width: 185px" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item :required="true" label="联系人电话">
                    <a-input
                      v-model="item.lessorsPhone"
                      :max-length="11"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      style="width: 185px"
                      type="number"
                      @blur="getLessorsPhone"
                      @change="validateLessorsPhone(item.lessorsPhone, index)"
                    />
                    <p style="font-size: 12px; color: red">{{ item.phoneTips }}</p>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item :required="true" label="业主类型">
                    <a-select v-model="item.lessorsType" style="width: 185px" @change="getLessorsType">
                      <a-select-option v-for="lessor in lessorTypeList" :key="lessor.dictValue" :value="lessor.dictValue">
                        {{ lessor.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="form.lessorInfoBoList.length !== 1" :span="4">
                  <a-button class="addInfor" type="link" @click="delClick(index)">
                    <a-icon :style="{ fontSize: '24px', color: 'red' }" type="minus-circle" />
                  </a-button>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item label="区域" prop="districtId">
                    <a-select v-model="form.districtId" style="width: 185px" @change="regionChange($event, 'addRentHouse')">
                      <a-select-option v-for="item in region" :key="item.areaId" :value="item.areaId">{{ item.areaName }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="商圈" prop="businessDistrictId">
                    <a-select
                      v-model="form.businessDistrictId"
                      :default-active-first-option="false"
                      :filter-option="false"
                      :not-found-content="null"
                      :show-arrow="true"
                      show-search
                      style="width: 175px"
                      @change="businessDistrictMethod($event, 'addRentHouse')"
                      @search="businessDisSearch"
                    >
                      <!-- @keyup.enter.native="onEnterPress()" -->
                      <a-select-option v-for="item in businessDistrict" :key="item.id" :value="item.id">
                        {{ item.businessDistrictName }}
                      </a-select-option>
                      <!-- :value="item.businessDistrictName" -->
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="街道" prop="streetId">
                    <a-select
                      v-model.trim="form.streetId"
                      :default-active-first-option="false"
                      :filter-option="false"
                      :not-found-content="null"
                      :show-arrow="true"
                      show-search
                      style="width: 175px"
                      @change="StreetMethod($event, 'addRentHouse')"
                      @search="streetSearch"
                      @keyup.enter.native="onEnterStreet()"
                    >
                      <a-select-option v-for="item in StreetData" :key="item.id" :value="item.id">{{ item.streetFullName }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="houseNumber" label="门牌号" prop="houseNumber">
                    <a-select v-model="form.houseNumber" placeholder="门牌号" style="width: 160px" @change="houseNumberMethod">
                      <a-select-option v-for="(item, index) in doorNumData" :key="index" :value="item.houseNumber">
                        {{ item.houseNumber }}
                      </a-select-option>
                    </a-select>
                    <!-- <a-input
                      style="width: 65px"
                      @change="getSearchHouseMsg"
                      v-model="form.houseNumber"
                      @blur="
                        () => {
                          $refs.houseNumber.onFieldBlur()
                        }
                      "
                    /> -->
                    <span style="margin-left: 10px; margin-right: 10px">号</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <div style="display: flex">
                    <a-form-model-item ref="houseNumberDeputy" label="附号" prop="houseNumberDeputy">
                      附
                      <a-select v-model="form.houseNumberDeputy" placeholder="附号" style="width: 160px" @change="houseNumberDeputyChange">
                        <a-select-option v-for="item in attachedNumberData" :key="item.id" :value="item.attachedNumber">
                          {{ item.attachedNumber }}
                        </a-select-option>
                      </a-select>
                      <span style="margin-left: 10px; margin-right: 10px">号</span>
                      <a-button class="search-btn" @click="getSearchHouseMsg">查询</a-button>
                    </a-form-model-item>
                  </div>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item prop="communityName" style="width: 185px">
                    <div class="dwyText dwybs">小区名称</div>
                    <a-input v-model="form.communityName"></a-input>
                    <!-- <a-input v-model="form.communityName" v-show="1 === 2"></a-input> -->
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="楼层" prop="houseFloorType">
                    <!-- 1单层2多层3独栋 -->
                    <a-select v-model="form.houseFloorType" placeholder="" style="width: 80px">
                      <a-select-option v-for="item in floorTypeOpts" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                    <span v-if="form.houseFloorType !== '3'">
                      第
                      <a-input v-model="form.houseFloor" style="width: 100px"></a-input>
                      层
                    </span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="floorTotal" label="整栋层数" prop="floorTotal">
                    <a-input
                      v-model="form.floorTotal"
                      :max-length="3"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="1"
                      style="width: 185px"
                      type="number"
                      @blur="
                        () => {
                          $refs.floorTotal.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>
              <p>基本信息</p>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="shopName" label="标题" prop="shopName">
                    <a-input
                      v-model="form.shopName"
                      :max-length="15"
                      style="width: 185px"
                      @blur="
                        () => {
                          $refs.shopName.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="商铺类型" prop="shopTypeId">
                    <a-select v-model="form.shopTypeId" placeholder="请选择" style="width: 185px">
                      <a-select-option v-for="item in shopType" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="商铺性质" prop="shopNatureId">
                    <a-select v-model="form.shopNatureId" placeholder="商铺性质" style="width: 185px" @change="shopNatureChange">
                      <a-select-option v-for="item in shopNature" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="经营状态" prop="operatingStatusId">
                    <a-select v-model="form.operatingStatusId" :disabled="form.shopNatureId === '3'" placeholder="空置中" style="width: 185px">
                      <a-select-option v-for="item in operatStatus" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col v-if="form.shopNatureId !== '3'" :span="4">
                  <a-form-model-item ref="industryCategoryId" label="现经营行业" prop="industryCategoryId">
                    <a-row style="min-width: 400px">
                      <a-col :span="11">
                        <a-select
                          v-model="form.industryCategoryId"
                          :disabled="form.shopNatureId === '3'"
                          :filter-option="filterOption"
                          placeholder="行业分类"
                          show-search
                          @blur="
                            () => {
                              $refs.industryCategoryId.onFieldBlur();
                            }
                          "
                          @change="getIndustryCategoryList"
                        >
                          <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id">
                            {{ item.industryCategoryName }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="11">
                        <a-select
                          v-model="form.industrySubclassId"
                          :disabled="form.shopNatureId === '3'"
                          :filter-option="filterOption"
                          placeholder="经营行业"
                          show-search
                          style="margin-left: 5px"
                          @change="getIndustrySubclassName"
                        >
                          <a-select-option v-for="item in industrySubclass" :key="item.id" :value="item.id">
                            {{ item.industryCategoryName }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4"></a-col>
                <a-col :span="4">
                  <a-form-model-item label="是否临街" prop="isFrontage">
                    <a-select v-model="form.isFrontage" placeholder="请选择" style="width: 185px">
                      <a-select-option v-for="item in weatherOpts" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="是否可餐饮" prop="isCatering">
                    <div style="display: flex">
                      <a-select v-model="form.isCatering" placeholder="请选择" style="width: 80px" @change="getState">
                        <a-select-option v-for="item in weatherOpts" :key="item.dictValue" :value="item.dictValue">
                          {{ item.dictLabel }}
                        </a-select-option>
                      </a-select>

                      <a-select v-if="form.isCatering === 'Y'" v-model="form.alloweCateringTypeId" placeholder="请选择" style="width: 105px">
                        <a-select-option v-for="item in repastTypeOpts" :key="item.dictValue" :value="item.dictValue">
                          {{ item.dictLabel }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="grossFloorArea" label="建筑面积" prop="grossFloorArea">
                    <a-input
                      v-model="form.grossFloorArea"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="m²"
                      type="number"
                      @blur="rent"
                    ></a-input>
                  </a-form-model-item>
                  <!--
                      @blur="
                        () => {
                          $refs.grossFloorArea.onFieldBlur()
                        }
                      "
                      -->
                </a-col>
                <a-col :span="14">
                  <a-form-model-item>
                    <div class="dwyText dwybs">可经营行业</div>
                    <div style="display: flex; justify-content: space-between; align-items: flex-start">
                      <!-- v-model="form.industryCategoryJsonId" -->
                      <a-select
                        v-model="form.industryCategoryJsonId"
                        :filter-option="filterOption"
                        mode="multiple"
                        placeholder="行业大类"
                        style="margin-right: 5px"
                        @change="getCatJsonName"
                      >
                        <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id ? item.id.toString() : ''">
                          {{ item.industryCategoryName }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        v-model="form.industrySubclassJsonId"
                        :filter-option="filterOption"
                        mode="multiple"
                        placeholder="行业小类"
                        @change="getSubJsonName"
                      >
                        <a-select-option v-for="item in industrySubJsonList" :key="item.id" :value="item.id ? item.id.toString() : ''">
                          {{ item.industryCategoryName }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </a-col>
                <!-- <a-col :span="4">
                  <a-form-model-item label=" " :colon="false">
                    <a-select
                      mode="multiple"
                      v-model="form.industrySubclassJsonId"
                      @change="getSubJsonName"
                      placeholder="行业小类"
                    >
                      <a-select-option v-for="item in industrySubJsonList" :key="item.id" :value="item.id">{{
                        item.industryCategoryName
                      }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col> -->
              </a-row>

              <a-row>
                <a-col :span="4">
                  <a-form-model-item prop="pooledAreaRatio">
                    <div class="dwyText dwybs">公摊</div>
                    <a-input
                      v-model="form.pooledAreaRatio"
                      :max-length="6"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="%"
                      type="number"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item prop="saleableArea">
                    <div class="dwyText dwybs">实用面积</div>
                    <a-input
                      v-model="form.saleableArea"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="m²"
                      type="number"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="houseWide" prop="houseWide">
                    <div class="dwyText dwybs">开间</div>
                    <a-input
                      v-model="form.houseWide"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="m"
                      type="number"
                      @blur="
                        () => {
                          $refs.houseWide.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="houseHigh" prop="houseHigh">
                    <div class="dwyText dwybs">层高</div>
                    <a-input
                      v-model="form.houseHigh"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="m"
                      type="number"
                      @blur="
                        () => {
                          $refs.houseHigh.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="houseLong" prop="houseLong">
                    <div class="dwyText dwybs">进深</div>
                    <a-input
                      v-model="form.houseLong"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="m"
                      type="number"
                      @blur="
                        () => {
                          $refs.houseLong.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>
              <p>价格信息</p>
              <a-row>
                <a-col :span="7">
                  <a-form-model-item ref="rentFee" label="租金/单价" prop="rentFee">
                    <div style="display: flex">
                      <div>
                        <template v-if="priceType === 'money'">
                          <a-input
                            v-model="form.rentFee"
                            :disabled="is_input_rentFee"
                            :max-length="10"
                            :suffix="priceType == 'money' ? '元/月' : '元/m²/月'"
                            onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                            step="0.1"
                            style="width: 140px"
                            type="number"
                            @blur="rent"
                          />
                        </template>
                        <template v-else>
                          <a-input
                            v-model="price"
                            :disabled="is_input_rentFee"
                            :max-length="10"
                            :suffix="priceType == 'money' ? '元/月' : '元/m²/月'"
                            onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                            step="0.1"
                            style="width: 140px"
                            type="number"
                            @blur="priceChange"
                          />
                        </template>
                        <!-- <span class="ml10"> {{ form.rentFeeCentiare }}</span
                        ><span>元/m²/月</span> -->
                        <!-- <span class="ml10">{{ parseFloat(form.rentFeeCentiare / 30).toFixed(2) }}</span
                        ><span>元/m²/天</span> -->
                        <a-radio-group v-model="priceType" button-style="solid" class="mg-l-10" default-value="money" @change="changePriceType">
                          <a-radio-button value="money">租金</a-radio-button>
                          <a-radio-button value="price">单价</a-radio-button>
                        </a-radio-group>
                      </div>
                      <!-- <div>
                        <span class="ml10"> {{ form.rentFeeCentiare }}</span><span>元/m²/月</span>
                        <span class="ml10">{{ parseFloat(form.rentFeeCentiare / 30).toFixed(2) }}</span><span>元/m²/天</span>
                      </div> -->
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="rentfreePeriod" label="免租期" prop="rentfreePeriod">
                    <a-input
                      v-model="form.rentfreePeriod"
                      :max-length="10"
                      class="w120"
                      placeholder="可谈或面议"
                      @blur="
                        () => {
                          $refs.rentfreePeriod.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4" style="display: flex">
                  <a-form-model-item ref="isHaveTransferFee" label="是否有转让费" prop="isHaveTransferFee">
                    <a-select v-model="form.isHaveTransferFee" placeholder="请选择" style="width: 80px">
                      <a-select-option v-for="item in weatherOpts" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item v-if="form.isHaveTransferFee === 'Y'" ref="transferFee" label="单位(万元)" prop="transferFee">
                    <a-input
                      v-model="form.transferFee"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      placeholder="转让费"
                      step="0.1"
                      style="width: 80px"
                      type="number"
                      @blur="
                        () => {
                          $refs.transferFee.onFieldBlur();
                        }
                      "
                    />
                    <!-- suffix="万元" -->
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="产权性质" prop="propertyNatureId">
                    <a-select v-model="form.propertyNatureId" class="w120" placeholder="商业">
                      <a-select-option v-for="item in propertyNature" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="7">
                  <a-form-model-item :required="true" label="支付方式">
                    <div style="display: flex">
                      <span>押&nbsp;</span>
                      <a-input
                        v-model="paymentMethod1"
                        :max-length="6"
                        onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                        style="width: 80px"
                        suffix="月"
                        type="number"
                      />
                      <span>付&nbsp;</span>
                      <a-input
                        v-model="paymentMethod2"
                        :max-length="6"
                        onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                        style="width: 80px"
                        suffix="月"
                        type="number"
                      />
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="递增">
                    <a-input v-model="form.progressiveIncrease" :max-length="25" style="width: 185px" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="houseBrokerage" label="房佣" prop="houseBrokerage">
                    <a-input
                      v-model="form.houseBrokerage"
                      :max-length="11"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 178px"
                      suffix="月"
                      type="number"
                      @blur="
                        () => {
                          $refs.houseBrokerage.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="7">
                  <a-form-model-item ref="propertyFee" prop="propertyFee">
                    <div class="dwyText dwybs">商业物业费</div>
                    <a-input
                      v-model="form.propertyFee"
                      :max-length="8"
                      :maxLength="100"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="元"
                      type="number"
                      @blur="
                        () => {
                          $refs.propertyFee.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="electricityFee" prop="electricityFee">
                    <div class="dwyText dwybs">商业电费</div>
                    <a-input
                      v-model="form.electricityFee"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="元/度"
                      type="number"
                      @blur="
                        () => {
                          $refs.electricityFee.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="waterFee" prop="waterFee">
                    <div class="dwyText dwybs">商业水费</div>
                    <a-input
                      v-model="form.waterFee"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="元/吨"
                      type="number"
                      @blur="
                        () => {
                          $refs.waterFee.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="gasFee" prop="gasFee">
                    <div class="dwyText dwybs">商业气费</div>
                    <a-input
                      v-model="form.gasFee"
                      :max-length="8"
                      onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                      step="0.1"
                      style="width: 185px"
                      suffix="元/m³"
                      type="number"
                      @blur="
                        () => {
                          $refs.gasFee.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>

              <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item label="商铺配套" prop="shopAncillaryArr">
                    <ul style="margin-left: 0; padding-left: 0px">
                      <li style="margin-bottom: 20px; margin-top: 10px">
                        <a-checkbox-group v-model="form.shopAncillaryArr" @change="shopAncillaryChange">
                          <a-checkbox v-for="item in shopAncillaryOpts" :key="item.dictValue" :value="item.dictLabel">
                            {{ item.dictLabel }}
                            <!-- <span v-if="item.dictLabel == '天然气'">
                              <label for="">气量</label>
                              <input class="input_val" type="number" v-model="form.gasCapacity" suffix="m³" />
                            </span>
                            <span v-if="item.dictLabel == '动力电'">
                              <label for="">电功率</label>
                              <input class="input_val" type="number" v-model="form.electricPower" suffix="kw" />
                            </span> -->
                          </a-checkbox>
                        </a-checkbox-group>
                      </li>
                    </ul>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <!-- <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item label="客流人群">
                    <a-checkbox-group @change="trafficCrowdChange" v-model="form.trafficCrowdArr">
                      <a-checkbox v-for="item in trafficCrowdOpts" :key="item.dictValue" :value="item.dictLabel">
                        {{ item.dictLabel }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-model-item>
                </a-col>
              </a-row> -->
              <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item label="消费配套">
                    <a-checkbox-group v-model="form.consumeAncillaryIdArr" @change="consumeAncillaryChange">
                      <a-checkbox v-for="item in consumeAncillaryOpts" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item label="自定义标签">
                    <a-checkbox-group v-model="form.tagsIdArr" @change="tagChange">
                      <a-checkbox v-for="item in CusListData" :key="item.id" :value="item.id">
                        {{ item.tagName }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>
              <p class="dwyText dwybs">房源优势</p>
              <a-textarea
                v-model="form.houseDescription"
                :autoSize="true"
                :maxLength="500"
                placeholder="房源优势信息（包括周边楼盘、停车、消费人群介绍、周边品牌、推荐行业等信息）"
                style="width: 100%; height: 200px; border-radius: 10px"
              />
              <p>备注</p>
              <a-textarea
                v-model="form.otherInfo"
                :autoSize="true"
                :maxLength="500"
                placeholder="请输入备注信息"
                style="width: 100%; height: 200px; border-radius: 10px"
              />
              <div class="submit-btns" style="text-align: center">
                <a-form-model-item>
                  <a-button :disabled="isExists" class="submit" type="primary" @click="onSubmit">提交</a-button>
                </a-form-model-item>
              </div>
            </a-form-model>
          </div>
        </div>
      </aside>
      <!-- <a-modal :visible="visibleDetials" :maskClosable="false" @cancel="visibleDetials=false" title="录入的门牌号已存在房源，请点击确定查看" @ok="handleDetails">
          <p>房源编号：</p>
          <p>{{houseCode}}</p>
        </a-modal> -->
      <a-modal v-model="isBanbetsu" title="新增房源可以选择入盘类别" @ok="handleOkBanbetsu">
        <a-radio-group v-model="form.dishType">
          <a-radio v-for="it of categoryList" :key="it.dictValue" :value="it.dictValue">
            {{ it.dictLabel }}
          </a-radio>
        </a-radio-group>
      </a-modal>
      <a-modal v-model="visibleDetials" :footer="null" on-ok="handleOk" title="温馨提示">
        <p class="">
          录入的门牌号已存在房源：
          <a @click="handleDetails()">{{ houseCode }}</a>
          ,请前往查看!!!
        </p>
      </a-modal>
      <div style="height: 50px"></div>
    </div>
  </div>
</template>

<script>
import houseApi from '@/api/system/houses/house.js';
import { industryCategoryList } from '@/api/system/industry';
import { singleSelectMixin } from '@/mixin/singleSelect';
import beforeRouteLeaveMixin from '@/mixin/beforeRouteLeave';

export default {
  name: 'HousesAdd',
  components: {},
  mixins: [singleSelectMixin, beforeRouteLeaveMixin],
  data() {
    return {
      rentSaleType: '1', // 租房
      inSubJsonListAll: [],
      industrySubJsonList: [],
      is_input_rentFee: true,
      lessorsPhoneArr: [],
      visibleDetials: false,
      houseCode: undefined,
      typeArr: [],
      transferorArr: [],
      twoRoomArr: [],
      detailsId: undefined,
      agentArr: [],
      lessorTypeList: [], // 业主类型
      isExists: false, // 提交按钮是否置灰
      gettypefunname: '房源/新增出租',
      addoredit: 0, // 0是新增 1是编辑
      labelCol: { span: 24, offset: 0 },
      wrapperCol: { span: 24 },
      value: 1,
      other: '',
      isBanbetsu: false, // 入盆类别选择弹窗
      categoryList: [], // 入盘类别
      dataInfo: {},
      community: {}, // 小区信息
      form: {
        channelResource: '1',
        dishType: '', // 选择入盘类别
        rentSaleType: '1',
        industryCategoryJsonKeyValueId: {},
        industryCategoryJsonName: [], // 行业大类名称
        industryCategoryJsonId: [], // 行业大类ID
        industrySubclassJsonName: [], // 行业小类名称
        industrySubclassJsonId: [], // 行业小类ID
        lessorsType: undefined, // 业主类型
        gasFee: undefined, //	气费
        communityName: undefined, //	小区全称
        communityId: undefined, //	小区id
        areaId: undefined, //	行政区ID
        alloweCateringTypeId: undefined, //	允许的餐饮类型ID 字典表类型：repast_type		false
        businessDistrictId: [], //	商圈id		true
        businessDistrictName: undefined, //	商圈名称		true
        districtId: [], //	区域id		true
        districtName: undefined, //	区域名称		true
        electricPower: undefined, //	电功率		false
        electricityFee: undefined, //	商业电费（元/度）		false
        floorTotal: undefined, //	总楼层		true
        gasCapacity: undefined, //	天然气容量		false
        grossFloorArea: undefined, //	建筑面积		true
        houseBrokerage: undefined, //	房佣		true
        houseFloor: undefined, //	楼层 字典表类型：floor_num		true
        houseHigh: undefined, //	层高		true
        houseLong: undefined, //	进深		true
        houseNumber: undefined, //	门牌号		true
        houseNumberId: undefined, //	门牌号id	true(实际无，门牌号与附号在同一条记录，门牌号未单独列出)
        houseNumberDeputy: undefined, //	门牌附号		false
        houseNumberDeputyId: undefined, //	门牌附号id
        houseWide: undefined, //	开间（面宽）		true
        id: undefined, //	id，新增时不传，修改时必传		true
        industryCategoryId: undefined, //	行业分类 字典表类型：industry_category		true
        industrySubclassId: undefined, //	经营行业 字典表类型：industry_subclass		true
        isCatering: undefined, //	是否可餐饮		true
        isEjectSmoke: undefined, //	是否有排烟		true
        isElevator: undefined, //	是否有电梯		true
        isFrontage: 'Y', //	是否临街 字典表类型：sys_yes_no		true
        isGas: undefined, //	是否有天然气		true
        isOfficePass: undefined, //	是否是办公人群		true
        isOtherPass: undefined, //	是否是其它人群		true
        isOutsideArea: undefined, //	是否有外摆区		true
        isParkingSpace: undefined, //	是否有停车位		true
        isPower: undefined, //	是否有动力电		true
        isResidentsPass: undefined, //	是否是居民人群		true
        isSewerSystem: undefined, //	是否有下水		true
        isStudentsPass: undefined, //	是否是学生人群		true
        isTouristPass: undefined, //	是否是旅游人群		true
        isTwowayStairs: undefined, //	是否有双步梯		true
        isWaterworks: undefined, //	是否有上水		true
        lessorInfoBoList: [
          {
            //	业主信息		true
            id: undefined, //	id，新增时不传，修改时必传		true
            lessorsName: undefined, //	业主姓名		true
            lessorsPhone: undefined, //	业主电话
            lessorsType: '', //	业主类型
            phoneTips: '', // 电话输入错误提示
            rentSaleType: '1' // 租房
          }
        ],
        operatingStatusId: undefined, //	经营状态 字典表类型：operating_status		true
        otherInfo: undefined, //	其它信息		false
        houseDescription: undefined, // 商铺介绍
        paymentMethod: undefined, //	支付方式;以YxFx，方式表示，如Y2F3 - 代表押2付3		true
        progressiveIncrease: undefined, //	递增		false
        propertyFee: undefined, //	商业物业费（元）		false
        propertyNatureId: undefined, //	产权性质ID 字典表类型：property_nature		true
        rentFee: 0, //	租金（元/月）		true
        rentFeeCentiare: 0, //
        rentfreePeriod: undefined, //	免租期（天）		true
        saleableArea: undefined, //	实用面积		true
        shopName: undefined, //	店铺标题		true
        shopNatureId: undefined, //	商铺性质 字典表类型：shop_nature		true
        shopTypeId: undefined, //	商铺类型 字典表类型：shop_type		true
        streetId: [], //	街道id		true
        streetName: undefined, //	街道名称		true
        tagsContentArray: undefined, //	自定义标签内容数组;标签内容以逗号分隔		false
        tagsIdArray: undefined, //	自定义标签id数组;标签id以逗号分隔		false
        transferFee: undefined, //	转让费（万元）		true
        isHaveTransferFee: undefined, // 是否接受转让费 字典表类型：sys_yes_no
        waterFee: undefined, //	商业水费（吨）
        shopAncillary: '', //	商铺配套名称，多个之间用逗号隔开 字典表类型：shop_ancillary
        shopAncillaryIds: [], // 商铺配套 id集
        trafficCrowd: '', //	客流人群名称，多个之间用逗号隔开 字典表类型：traffic_crowd
        shopAncillaryArr: [],
        trafficCrowdArr: [],
        tagsIdArr: [],
        tagsContentArr: [],
        pooledAreaRatio: undefined, // 公摊面积占比
        consumeAncillaryArr: [],
        consumeAncillaryIds: undefined, // 消费配套IDs（字符串，多个之间用逗号隔开）
        consumeAncillaryIdArr: [], // 消费配套IDs （数组 ，显示）
        consumeAncillary: undefined, // 消费配套，多个之间用逗号隔开
        houseFloorType: undefined
      },
      newform: {
        isGas: false,
        isOutsideArea: false,
        isPower: false,
        isEjectSmoke: false,
        isSewerSystem: false,
        isWaterworks: false,
        isElevator: false,
        isParkingSpace: false,
        isTwowayStairs: false,
        isOfficePass: false,
        isStudentsPass: false,
        isResidentsPass: false,
        isTouristPass: false,
        isOtherPass: false
      },

      // 楼层数
      floorData: [],
      // 楼层类型
      floorTypeOpts: [],
      // 商铺类型
      shopType: [],
      // 商铺性质
      shopNature: [],
      // 经营状态
      operatStatus: [],
      // 行业分类
      industryCategory: [],
      // 经营行业（行业子类）
      industrySubclass: [],
      // 餐饮类型
      repastType: [],
      // 产权性质
      propertyNature: [],
      weatherOpts: [], // 是否
      shopAncillaryOpts: [], // 商铺配套名称
      trafficCrowdOpts: [], // 客流人群
      repastTypeOpts: [], // 允许的餐饮类型
      consumeAncillaryOpts: [], // 消费配套

      shopAncillary: [],
      trafficCrowdArr: [],

      food1: '',
      paymentMethod1: 1,
      paymentMethod2: 1,
      // 查询房源信息是否存在弹出框的展示值
      overShow: false,
      food: [
        { id: 0, title: '可轻餐' },
        { id: 1, title: '可重餐' }
      ],

      // // 商圈
      businessDistrict: [],

      // 门牌号
      doorNumData: [],
      // 附号
      attachedNumberData: [],
      // 可餐饮状态
      isCateringStatus: 'false',
      rules: {
        // houseFloor
        houseFloorType: [{ required: true, message: '请选择楼层类型信息', trigger: 'blur' }],
        // communityName: [{ required: true, message: '请选择楼层', trigger: 'change' }],
        shopName: [{ required: true, message: '请输入店铺标题', trigger: 'blur' }],
        lessorsName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 4, message: '姓名不正确', trigger: 'blur' }
        ],
        districtId: [{ required: true, message: '请选择区域', trigger: 'change' }],
        businessDistrictId: [{ required: true, message: '请选择商圈', trigger: 'change' }],
        streetId: [{ required: true, message: '请选择街道', trigger: 'change' }],
        shopTypeId: [{ required: true, message: '请选择商铺类型', trigger: 'change' }],
        shopNatureId: [{ required: true, message: '请选择商铺性质', trigger: 'change' }],
        operatingStatusId: [{ required: true, message: '请选择经营状态', trigger: 'change' }],
        industryCategoryId: [{ required: true, message: '请选择经营分类', trigger: 'change' }],
        propertyNatureId: [{ required: true, message: '请选择产权性质', trigger: 'change' }],
        isFrontage: [{ required: true, message: '请选择是否临街', trigger: 'change' }],
        isCatering: [{ required: true, message: '请选择是否可餐饮', trigger: 'change' }],
        pooledAreaRatio: [
          {
            required: false,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          {
            validator: (rule, val, callback) => {
              if (parseFloat(val) > 100) {
                callback(new Error('比例不可超过100%'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, val, callback) => {
              if (parseFloat(val) > 100) {
                callback(new Error('比例不可超过100%'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        shopAncillaryArr: [
          {
            type: 'array',
            required: true,
            message: '请选择商铺配套',
            trigger: 'change'
          }
        ],
        // shopAncillaryArr: [
        //   {
        //     type: 'array',
        //     required: true,
        //     message: '请选择商铺配套',
        //     trigger: 'change'
        //   }
        // ],
        rentFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入租金', trigger: 'blur' },
          { min: 0, message: '租金不得小于零', trigger: 'blur' }
        ],
        saleableArea: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        lessorsPhone: [
          { pattern: /^1[3-9][0-9]{9}$/, message: '格式错误', trigger: 'blur' },
          { required: true, message: '请输入电话号码', trigger: 'blur' }
          // { min: 11, max: 11, message: '请输入正确的电话号码', trigger: 'blur' },
        ],
        houseNumber: [{ required: true, message: '请选择门牌号', trigger: 'blur' }],
        houseNumberDeputy: [{ required: true, message: '请选择附号', trigger: 'blur' }],
        // communityName: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        grossFloorArea: [
          { required: true, message: '请输入建筑面积', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { message: '建筑面积不得小于零', trigger: 'blur' }
        ],
        houseWide: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { min: 1, message: '开间数不得小于零125', trigger: 'blur' }
        ],
        houseHigh: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { min: 1, message: '层高不得小于零', trigger: 'blur' }
        ],
        floorTotal: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
          // { required: true, message: '请输入整栋层数', trigger: 'blur' }
          // { min: 1, message: '层数不得低于0', trigger: 'blur' },
        ],
        houseLong: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { min: 1, message: '进深不得小于零', trigger: 'blur' }
        ],
        // rentfreePeriod: [
        //   // { pattern: /^(([0-9]+)|([1-9][0-9]*))$/, message: '格式错误', trigger: 'blur' },
        //   { required: false, message: '请输入免租期', trigger: 'blur' }
        // ],
        isHaveTransferFee: [{ required: true, message: '请选择是否有转让费', trigger: 'blur' }],
        transferFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入转让费', trigger: 'blur' },
          { min: 1, message: '转让费不得小于零', trigger: 'blur' }
        ],
        paymentMethod: [
          { required: true, message: '请输入转让月数', trigger: 'blur' },
          { min: 1, message: '转让月数不得小于零', trigger: 'blur' }
        ],
        houseBrokerage: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入房佣金', trigger: 'blur' }
          // { min: 1, message: '房拥不得小于零', trigger: 'blur' },
        ],
        propertyFee: [
          {
            // pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            // message: '格式错误',
            // trigger: 'blur',
            // message: '请输入物业费',
            // required: true
          }
        ],
        electricityFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        waterFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        gasFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ]
      },
      oneShow: false,
      twoShow: false,
      isWatch: false,
      addBtnShow: true,
      a: 0,
      // 自定义标签
      CusListData: [],
      // 新增自定义标签
      addCusData: {},
      houseId: '',
      updateStatus: false, // 默认不是更新数据
      priceType: 'money', // 显示价格类型，money是租金，price是单价
      money: 0,
      price: 0 // 单价
    };
  },
  created() {
    this.init();
  },
  activated() {
    const storage = sessionStorage.getItem('history');
    console.log(storage, 'storage');
    let data = {};
    if (storage) {
      data = JSON.parse(storage);
      if (data.fromPage === 'add') {
        //  this.updateStatus = true
        this.resetForm();
        // this.reload()
        Object.keys(this.form).forEach((el) => {
          if (Array.isArray(this.form[el])) {
            if (el == 'lessorInfoBoList') {
              this.form.lessorInfoBoList = [
                {
                  lessorsName: undefined, //	业主姓名		true
                  lessorsPhone: undefined, //	业主电话
                  lessorsType: undefined, //	业主类型
                  rentSaleType: '1' // 售房
                }
              ];
            } else {
              this.form[el] = [];
            }
          } else {
            this.form[el] = null;
          }
        });
        // this.updateStatus = false
      }
      this.init();
    } else {
      if (this.houseId !== this.$route.query.id) {
        this.init();
      }
    }
    // console.log(this.houseId,this.$route.query.id,'9988877')
  },
  deactivated() {
    sessionStorage.removeItem('history');
  },
  methods: {
    init() {
      this.isWatch = false;
      // 区域列表
      this.getDistrict('addRentHouse', 'init');
      this.getDicts('channel_resource').then((response) => {
        console.log(response);
      });
      // 盘别
      this.getDicts('dish_type').then((response) => {
        console.log(response.data, '入盘类别');
        this.categoryList = response.data;
      });
      // 行业分类
      this.getinSubJsonListAll();
      this.getIndustryCategory(1);
      this.getDicts('sys_yes_no').then((response) => {
        this.weatherOpts = response.data;
      });
      this.getDicts('shop_ancillary').then((response) => {
        this.shopAncillaryOpts = response.data;
      });

      this.getDicts('traffic_crowd').then((response) => {
        this.trafficCrowdOpts = response.data;
      });
      // 消费配套
      this.getDicts('consume_ancillary').then((response) => {
        this.consumeAncillaryOpts = response.data;
      });

      this.getDicts('repast_type').then((response) => {
        this.repastTypeOpts = response.data;
        this.repastTypeOpts.forEach((item) => {
          if (item.dictLabel === '拒餐饮') {
            // a删除拒餐饮
            this.repastTypeOpts.splice(item.dictSort - 1, 1);
          }
        });
      });
      this.getCusTag();
      this.houseId = this.$route.query.id;
      if (this.$route.query.tpfunname && this.houseId) {
        // 编辑跳转的
        this.gettypefunname = this.$route.query.tpfunname;
        this.addoredit = 1;
        this.getHouseDetails();

        // 通过房源id调用接口获取房源详情  渲染到界面上
      } else {
        this.addoredit = 0;
      }

      // 楼层数
      this.getDicts('floor_num').then((res) => {
        if (res.code === 200) {
          this.floorData = res.data;
        }
      });
      // 楼层类型
      this.getDicts('floor_type').then((res) => {
        if (res.code === 200) {
          this.floorTypeOpts = res.data;
        }
      });
      // 商铺类型
      this.getDicts('shop_type').then((res) => {
        if (res.code === 200) {
          this.shopType = res.data;
        }
      });
      // 商铺性质
      this.getDicts('shop_nature').then((res) => {
        if (res.code === 200) {
          this.shopNature = res.data;
        }
      });
      // 经营状态
      this.getDicts('operating_status').then((res) => {
        if (res.code === 200) {
          this.operatStatus = res.data;
        }
      });

      // this.getDicts('industry_category').then((res) => {
      //   if (res.code === 200) {
      //     this.industryCategory = res.data
      //   }
      // })
      // 经营行业（行业子类）
      // this.getDicts('industry_subclass').then((res) => {
      //   if (res.code === 200) {
      //     this.industrySubclass = res.data
      //   }
      // })
      // 餐饮类型
      this.getDicts('industry_subclass').then((res) => {
        if (res.code === 200) {
          this.repastType = res.data;
        }
      });
      // 产权性质
      this.getDicts('property_nature').then((res) => {
        if (res.code === 200) {
          this.propertyNature = res.data;
        }
      });
      // 获取业主类型字典
      this.getDicts('lessor_type').then((res) => {
        if (res.code === 200) {
          this.lessorTypeList = res.data;
        }
      });
    },
    // 确定选择入盘类别
    handleOkBanbetsu() {
      if (!this.form.dishType) {
        this.$message.warning('请选择入盘类别');
        return false;
      }
      // 新增
      this.addhouse();
    },
    // 可经营-获取行业大类名字+小类列表
    getCatJsonName(val) {
      this.form.industryCategoryJsonName = [];
      console.log(val, this.industryCategory, '000');
      if (val && val.length) {
        for (const parentId of val) {
          this.industryCategory.find((item) => {
            if (item.id === parentId || item.id.toString() === parentId) {
              // 行业大类
              this.form.industryCategoryJsonName.push(item.industryCategoryName);
            }
          });
        }
      }
      this.git_industryCategoryList(val);
    },
    git_industryCategoryList(val) {
      // console.log(val, '数据', this.inSubJsonListAll)
      let arr = [];
      let reduceArr = []; // 每次减少
      const addArr = []; // 每次增加
      val.forEach((el) => {
        const filterArr = this.inSubJsonListAll.filter((it) => el == it.parentId);
        arr = [...arr, ...filterArr];
        if (this.parentsId) {
          this.parentsId.forEach((it) => {
            const item = val.find((ele) => ele === it);
            if (!item) {
              reduceArr.push(it);
            }
          });
          const opt = this.parentsId.find((it) => it === el);
          if (!opt) {
            addArr.push(el);
          }
          reduceArr = [...new Set(reduceArr)];
        }
      });
      this.industrySubJsonList = arr;
      if (addArr.length) {
        addArr.forEach((el) => {
          const addfilterArr = this.inSubJsonListAll.filter((it) => el == it.parentId);
          this.form.industrySubclassJsonId = [...this.form.industrySubclassJsonId, ...addfilterArr.map((it) => it.id + '')];
        });
      }
      if (reduceArr.length) {
        reduceArr.forEach((el) => {
          const reduceFilter = this.inSubJsonListAll.filter((it) => el == it.parentId);
          for (let i = 0; i <= reduceFilter.length - 1; i++) {
            const idx = this.form.industrySubclassJsonId.findIndex((it) => it == reduceFilter[i].id);
            if (idx >= 0) {
              // console.log(idx,this.form.industrySubclassJsonId[idx],'999')
              this.form.industrySubclassJsonId.splice(idx, 1);
            }
          }
        });
      }
      if (!addArr.length && !reduceArr.length) {
        this.form.industrySubclassJsonId = arr.map((el) => el.id + '');
      }
      this.form.industrySubclassJsonId = [...new Set(this.form.industrySubclassJsonId)];
      this.parentsId = this.form.industryCategoryJsonId;

      // console.log(reduceArr, addArr, 'xiao', this.parentsId, this.form.industrySubclassJsonId)
      return;
      const parmars = {
        // parentId: val[val.length - 1],
        parentId: undefined,
        industryCategoryType: 2
      };
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          const allSubList = data;
          const list_ = allSubList.filter((item) => {
            return val.indexOf(item.parentId) > -1 || val.indexOf(item.parentId.toString()) > -1;
          });
          this.industrySubJsonList = list_;
          const newSelSubIds = [];
          const newSelSubNames = [];
          // 选择的子类
          const selSubIds = this.form.industrySubclassJsonId;
          // for (const showsub of this.industrySubJsonList) {
          //     if (selSubIds.indexOf(showsub.id) > -1 || selSubIds.indexOf(showsub.id.toString()) > -1) {
          //     newSelSubIds.push(showsub.id.toString())
          //     newSelSubNames.push(showsub.industrySubclassJsonName)
          //   }
          // }
          // 子类默认全部选择
          const ids = [];
          // 循环当前选中父类下的所有子类
          const datas = this.industrySubJsonList.filter((item) => selSubIds.includes(item.id.toString()));
          for (const showsub of this.industrySubJsonList) {
            // 判断具备跟选择子类相同的父类id
            // 通过所有的子类数据 根据当前数据selSubIds选择了的子类 判断所有子类数据是否存在跟当前选择的数据具备相同的父类
            if (datas && datas.length) {
              if (datas[0].parentId.toString() !== showsub.parentId.toString()) {
                // 把选择了的数据的相同父类下的数据都干掉使用选择了的子类数据
                ids.push(showsub.id.toString());
              }
            } else {
              ids.push(showsub.id.toString());
            }
          }
          // 父类匹配子类解决父类删除子类数据不删除问题
          const list = [...this.form.industrySubclassJsonId, ...ids];
          // 通过子类id匹配出子类数据
          const dataslist = this.industrySubJsonList.filter((item) => list.includes(item.id.toString()));
          // 通过子类数据中父类id去匹配父类id1数组
          const arrDaids = dataslist.filter((item) => this.form.industryCategoryJsonId.includes(item.parentId.toString())).map((res) => res.id + '');
          // this.form.industryCategoryJsonId
          this.form.industrySubclassJsonId = arrDaids; // 经营行业（行业小类）ID
          this.getSubJsonName(arrDaids);
        }
      });
    },
    // 获取全部子类
    getinSubJsonListAll() {
      const par = {
        parentId: '',
        industryCategoryType: 2
      };
      industryCategoryList(par).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.industrySubJsonList = data;
          this.inSubJsonListAll = data;
          // console.log('获取全部子类', this.inSubJsonListAll)
        }
      });
    },
    // 月租金和单价每平切换
    changePriceType() {
      // console.log(this.form.rentFee,'00000',this.form.grossFloorArea)
      if (this.form.rentFee) {
        if (this.priceType === 'money') {
          this.form.rentFee = Number(this.form.rentFee).toFixed(2);
        } else {
          this.price = (this.form.rentFee / this.form.grossFloorArea).toFixed(2) + '';
        }
      }
    },
    newArrFn(arr) {
      // .new Set方法，返回是一个类数组，需要结合 ...运算符，转成真实数组
      return [...new Set(arr)];
    },
    // 可经营-行业小类名字
    getSubJsonName(val) {
      this.form.industrySubclassJsonName = [];
      if (val.length) {
        for (const parentId of val) {
          this.inSubJsonListAll.forEach((item) => {
            if (item.id === parentId || item.id.toString() === parentId) {
              // 行业小类名称
              this.form.industrySubclassJsonName.push(item.industryCategoryName);
            }
          });
        }
        //  this.form.industrySubclassJsonId=val
      }
    },
    // 商铺性质为新房时，经营状态为空置中，现经营为空，不显示
    shopNatureChange(e) {
      if (e === '3') {
        // 1二手商铺 2招商项目 3新房
        this.form.operatingStatusId = '1'; // 经营状态 1空置中 2营业中
        // 现经营
        this.form.industryCategoryId = 15; // 行业大类 15其他
        this.form.industrySubclassId = 16; // 行业子类 16其他
      } else {
        // 1二手商铺 2招商项目 3新房
        this.form.operatingStatusId = '1'; // 经营状态 1空置中 2营业中
        this.form.industryCategoryId = undefined; // 行业大类 15其他
        this.form.industrySubclassId = undefined; // 行业子类 16其他
        // 现经营
        this.getIndustryCategoryList(this.form.industryCategoryId);
      }
    },
    // 行业分类
    getIndustryCategory(type) {
      industryCategoryList({ industryCategoryType: type }).then((res) => {
        if (res.code === 200) {
          // console.log('行业大类', res.data)
          this.industryCategory = res.data;
        }
      });
    },
    // 经营行业
    getIndustryCategoryList(parentId) {
      if (parentId) {
        this.form.industrySubclassId = undefined;
        this.form.industrySubclassName = undefined;
        this.industryCategory.find((item) => {
          if (item.id === parentId) {
            //  行业大类
            this.form.industryCategoryName = item.industryCategoryName;
          }
        });
      }
      const parmars = {
        parentId,
        industryCategoryType: 2
      };
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res;
        this.loading = false;
        if (code === 200) {
          this.industrySubclass = data;
        }
      });
    },
    // 行业小类
    getIndustrySubclassName(id) {
      this.industrySubclass.find((item) => {
        if (item.id === id) {
          // 行业小类
          this.form.industrySubclassName = item.industryCategoryName;
        }
      });
    },
    getState() {
      this.form.alloweCateringTypeId = undefined;
    },
    // 获取房源的详细信息
    getHouseDetails() {
      houseApi.houseDetails(this.houseId).then((res) => {
        if (res.code === 200) {
          this.getlist(res.data.industryCategoryId);

          this.form = res.data;

          this.form.lessorInfoBoList = this.form.lessorInfoVoList;
          // console.log(this.form.lessorInfoBoList)
          const pleLIst = res.data.paymentMethod.split('F');
          this.paymentMethod1 = Number(pleLIst[0].replace('Y', ''));
          this.paymentMethod2 = Number(pleLIst[1]);
          this.form.shopAncillaryArr = this.form.shopAncillary ? this.form.shopAncillary.split(',') : this.form.shopAncillary;
          this.form.trafficCrowdArr = this.form.trafficCrowd ? this.form.trafficCrowd.split(',') : this.form.trafficCrowd;

          this.form.consumeAncillaryIds = JSON.parse(this.form.consumeAncillaryIds) || [];
          this.form.consumeAncillaryIdArr = JSON.parse(JSON.stringify(this.form.consumeAncillaryIds));
          this.form.districtId = JSON.parse(this.form.districtId) || [];
          this.form.businessDistrictId = JSON.parse(this.form.businessDistrictId) || [];
          this.form.streetId = JSON.parse(this.form.streetId) || [];

          if (this.form.tagsIdArray) {
            const tagsIdStrArr = this.form.tagsIdArray.split(',');
            this.form.tagsIdArr = tagsIdStrArr.map((value) => {
              return parseInt(value);
            });
          }
          // if (this.form.districtId) {
          //   // 商圈列表
          //   this.getBusinessDistrictList({ businessDistrictName: '', districtId: this.form.districtId }, null)
          //   // 街道列表
          //   this.getStreetList(null)
          // }
          // 行业大类名称
          const industryCategoryJsonName = this.form.industryCategoryJsonName;
          this.form.industryCategoryJsonName = industryCategoryJsonName ? JSON.parse(industryCategoryJsonName) : [];

          // 行业大类ID
          const industryCategoryJsonId = res.data.industryCategoryJsonId;
          this.form.industryCategoryJsonId = industryCategoryJsonId ? JSON.parse(industryCategoryJsonId) : [];
          // 行业小类名称
          const industrySubclassJsonName = res.data.industrySubclassJsonName;
          this.form.industrySubclassJsonName = industrySubclassJsonName ? JSON.parse(industrySubclassJsonName) : [];
          // 行业小类ID
          const industrySubclassJsonId = this.form.industrySubclassJsonId;
          this.form.industrySubclassJsonId = industrySubclassJsonId ? JSON.parse(industrySubclassJsonId) : [];
          // const industryCategoryJsonId = this.form.industryCategoryJsonId
          // if (industryCategoryJsonId) {
          //   this.form.industryCategoryJsonId = industryCategoryJsonId.map((item) => {
          //     return Number(item)
          //   })
          // }
          //  const industrySubclassJsonId = this.form.industrySubclassJsonId
          // if (industrySubclassJsonId) {
          //   this.form.industrySubclassJsonId = industrySubclassJsonId.map((item) => {
          //     return Number(item)
          //   })
          // }
          this.getStreetList();
          if (this.form.streetId) {
            this.getDoorNumData(this.form.streetId);
          }
          this.$forceUpdate();
        }
      });
    },
    // 回显行业分类小类
    getlist(id) {
      const parmars = {
        parentId: id,
        industryCategoryType: 2
      };
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res;
        this.loading = false;
        if (code === 200) {
          this.industrySubclass = data;
        }
      });
    },

    shopAncillaryChange(val) {
      if (!val) return;
      this.form.shopAncillaryArr = val;

      const IDLIST = [];
      const LIST = this.shopAncillaryOpts.filter((item) => {
        return val.indexOf(item.dictLabel) > -1;
      });
      for (const obj of LIST) {
        IDLIST.push(obj.dictValue);
      }
      //  console.log(LIST)
      this.form.shopAncillary = val.join(',');
      this.form.shopAncillaryIds = IDLIST;
      // console.log(val, this.form.shopAncillary, this.form.shopAncillaryIds)
      this.$forceUpdate();
    },

    trafficCrowdChange(val) {
      if (!val) return;
      if (val.length > 3) {
        val = val.splice(0, 3);
        this.$message.error('客流人群最多只能选3个，请慎重选择');
      }
      this.form.trafficCrowdArr = val;
      this.form.trafficCrowd = val.join(',');
      this.$forceUpdate();
    },

    consumeAncillaryChange(val) {
      if (!val) return;
      if (val.length > 4) {
        val = val.splice(0, 4);
        this.$message.error('消费配套最多只能选4个，请慎重选择');
      }
      this.form.consumeAncillaryIdArr = val;
      this.form.consumeAncillaryIds = val;
      const NAMELIST = [];
      const LIST = this.consumeAncillaryOpts.filter((item) => {
        return val.indexOf(item.dictValue) > -1;
      });
      for (const obj of LIST) {
        NAMELIST.push(obj.dictLabel);
      }
      this.form.consumeAncillary = NAMELIST.join(',');
      // this.form.consumeAncillaryIds = val.join(',')
      this.$forceUpdate();
    },
    tagChange(val) {
      this.form.tagsIdArr = val;
      if (!val) {
        return;
      }

      this.form.tagsIdArray = val.join(',');
      let tIdArr;
      if (this.form.tagsIdArray) {
        tIdArr = this.form.tagsIdArray.split(',');
      } else {
        this.form = { ...this.form };
        // console.log(this.form.tagsIdArr,'this.form.tagsIdArr')
        return;
      }
      const tagsNameArr = [];

      for (const item of this.CusListData) {
        for (const tId of tIdArr) {
          if (item.id == tId) {
            tagsNameArr.push(item.tagName);
          }
        }
      }
      this.form.tagsContentArray = tagsNameArr.join(',');
      this.$forceUpdate();
    },
    // // 获取商圈
    // getBusDistrict (data) {
    //   houseApi.businessDistrict(data).then((res) => {
    //     if (res.code === 200) {
    //       this.businessDistrict = res.data
    //       this.getStreetMethod()
    //     }
    //   })
    // },
    // 新增商圈
    getaddBusinessDistrict() {
      const params = {
        businessDistrictName: '吾悦广场33',
        businessDistrictScope: '奶牛广场33',
        districtId: 3,
        id: 3,
        isPrimaryBusinessDistrict: '是'
      };
      houseApi.addBusinessDistrict(params).then((res) => {});
    },

    // 重置附号信息
    resetHouseNumberDeputy() {
      this.form.houseNumberDeputy = undefined;
      this.form.houseNumberDeputyId = undefined;
    },

    // 根据街道id获取门牌号
    getDoorNumData(val) {
      // console.log(val, 'val0000')
      this.doorNumData = [];
      this.getStreetNumbers(val);
    },

    // 根据门牌号id获取附号信息
    houseNumberMethod(val) {
      this.resetHouseNumberDeputy();
      // 获取门牌号id
      // this.houseNumberChange(val)
      for (const item of this.doorNumData) {
        if (item.houseNumber === val) {
          this.attachedNumberData = item.attachedList;
          this.form.houseNumberId = item.attachedList[0].id;
          // this.form.houseNumberDeputyId = item.attachedList[0].id
          // this.form.houseNumberDeputy = item.attachedList[0].attachedNumber
          // 执行附号改变事件
          this.houseNumberDeputyChange(item.attachedList[0].attachedNumber, 'no');
        }
      }
      this.getCommunityInfoByQuery(val);
    },
    // 根据门牌号获取小区信息（有变动才触发）
    getCommunityInfoByQuery(houseNumber) {
      const query = {
        communityFullName: undefined, // 小区全称	query	false
        communityShortName: undefined, //	小区简称	query	false
        houseNumber: houseNumber, //	门牌号	query	false
        streetId: this.form.streetId //	街道ID
      };
      houseApi.getCommunityByQuery(query).then((response) => {
        this.community = response.data;
        const community_ = this.community;
        // console.log(community_, '=======================community_')
        if (community_ != null) {
          this.form.propertyFee = community_.propertyFee; // 物业费
          this.form.waterFee = community_.waterFee; //	水费
          this.form.electricityFee = community_.electricityFee; //	电费
          this.form.gasFee = community_.gasFee; //	气费
          this.form.communityName = community_.communityFullName; //	小区全称
          this.form.communityId = community_.id; //	小区id
          this.form.areaId = community_.areaId; //	行政区ID
        } else {
          this.form.propertyFee = undefined; // 物业费
          this.form.waterFee = undefined; //	水费
          this.form.electricityFee = undefined; //	电费
          this.form.gasFee = undefined; //	气费
          this.form.communityName = undefined; //	小区全称
          this.form.communityId = undefined; //	小区id
          this.form.areaId = undefined; //	行政区ID
        }
      });
    },
    // 门牌附号
    houseNumberDeputyChange(val, validteExist) {
      const newNum = this.doorNumData.find((item) => {
        return item.houseNumber === this.form.houseNumber;
      });
      const attachedList_ = newNum.attachedList;
      const newDeputyNum = attachedList_.find((item) => {
        return item.attachedNumber === val;
      });
      // console.log(newDeputyNum, 'newDeputyNum')
      if (newDeputyNum) {
        this.form.houseNumberDeputyId = newDeputyNum.id;
        this.form.houseNumberId = newDeputyNum.id;
      } else {
        this.form.houseNumberDeputyId = undefined;
      }
      if (validteExist !== 'no') {
        // 查询房源是否存在
        this.getSearchHouseMsg();
      }
    },
    getStreetNumbers(streetId) {
      if (!streetId) {
        return;
      }
      houseApi.getStreet(streetId).then((response) => {
        this.dataInfo = response.data;
        const volist = this.dataInfo.attachedInfoVoList;
        this.houseNumberArr = volist;
        this.dataInfo.attachedInfoBoList = volist;

        const houseNumberArr = [];
        const houseNumberArr_ = [];
        for (const vo of volist) {
          houseNumberArr_.push(vo.houseNumber);
        }
        var set = new Set(houseNumberArr_);
        // 将set转换为数组
        const [...newHouseNumberArr_] = set;

        const newHouseNumberArr = [];
        for (const obj of newHouseNumberArr_) {
          newHouseNumberArr.push({
            houseNumber: obj,
            attachedList: []
          });
        }

        const _arr = [];
        for (const h of newHouseNumberArr) {
          let attArr = [];
          for (const vo of volist) {
            houseNumberArr.push(vo.houseNumber);
            if (h.houseNumber === vo.houseNumber) {
              attArr.push(vo);
            }
          }
          h.attachedList = attArr;
          attArr = [];
          _arr.push(h);
        }
        this.doorNumData = _arr;
        this.initHouseNumberDeputyMethod(this.form.houseNumber);
      });
    },

    // 添加业主
    addClick() {
      if (this.form.lessorInfoBoList.length >= 5) {
        this.$message.error('最多只能添加5位联系人');
      } else {
        const obj = {
          lessorsName: undefined, //	业主姓名		true
          lessorsPhone: undefined, //	业主电话
          lessorsType: undefined //	业主类型
        };
        this.form.lessorInfoBoList.push(obj);
        this.$forceUpdate();
      }
    },
    getLessorsType() {
      const typeArr = []; // 两位业主信息
      const transferorArr = []; // 转让方
      const twoRoomArr = []; // 二房东
      const agentArr = []; // 二房东
      this.form.lessorInfoBoList.forEach((item) => {
        if (item.lessorsType === '1') {
          typeArr.push(item.lessorsType);
        }
        if (item.lessorsType === '2') {
          transferorArr.push(item.lessorsType);
        }
        if (item.lessorsType === '3') {
          twoRoomArr.push(item.lessorsType);
        }
        if (item.lessorsType === '4') {
          agentArr.push(item.lessorsType);
        }
      });
      this.transferorArr = transferorArr;
      this.typeArr = typeArr;
      this.twoRoomArr = twoRoomArr;
      if (typeArr.length >= 3) {
        this.$message.error('最多添加两位业主');
        return;
      }
      if (transferorArr.length >= 2) {
        this.$message.error('最多添加一位转让方');
        return;
      }
      if (twoRoomArr.length >= 2) {
        this.$message.error('最多添加一位二房东');
        return;
      }
      if (agentArr.length >= 2) {
        this.$message.error('最多添加一位代理人');
      }
    },
    // 判断电话是否重复
    getLessorsPhone() {
      // 判断电话是否重复
      const lessorsPhoneArr = [];
      this.form.lessorInfoBoList.forEach((item) => {
        if (item.lessorsPhone) {
          lessorsPhoneArr.push(item.lessorsPhone);
        }
      });
      this.lessorsPhoneArr = lessorsPhoneArr;
      for (var i = 0; i < lessorsPhoneArr.length; i++) {
        if (lessorsPhoneArr.indexOf(lessorsPhoneArr[i]) !== i) {
          this.$message.error('联系人电话不能重复');
          return;
        }
      }
    },
    // 动态绑定电话号码正则
    validateLessorsPhone(value, index) {
      // 判断电话是否错误
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      this.form.lessorInfoBoList.forEach((item, i) => {
        if (index === i) {
          if (!value || !reg.test(value)) {
            item.phoneTips = '请输入正确的电话号码';
          } else {
            item.phoneTips = '';
          }
        }
      });
    },
    // 删除业主
    delClick(index) {
      if (this.form.lessorInfoBoList.length === 1) {
        this.$message.warning('最少要添加一位联系人');
      } else {
        this.form.lessorInfoBoList.splice(index, 1);
        this.$forceUpdate();
      }
    },
    // 商铺change事件
    // shopChange(val) {},
    onSubmit() {
      // const arr = []
      console.log(this.$data, '====');

      // return
      const transArr = [];

      this.form.lessorInfoBoList.forEach((item) => {
        if (item.lessorsType === '2') {
          transArr.push(item.lessorsType);
        }

        // if (item.phoneTips) {
        //   this.$message.error('请输入正确的联系人电话')
        //   return
        // }
        if (!item.lessorsName || !item.lessorsPhone) {
          this.$message.error('请输入联系人信息');
          return;
        }
        console.log('不要删这个log');
        //  if (item.lessorsType === '1') {
        //   arr.push(item.lessorsType)
        // }
      });
      this.isphone = false;
      this.form.lessorInfoBoList.find((item) => {
        if (item.phoneTips) {
          this.isphone = true;
        }
      });
      if (this.isphone) {
        this.$message.error('请输入正确的联系电话');
        return;
      }
      for (var i = 0; i < this.lessorsPhoneArr.length; i++) {
        if (this.lessorsPhoneArr.indexOf(this.lessorsPhoneArr[i]) !== i) {
          this.$message.error('联系人电话不能重复');
          return;
        }
      }
      for (var p = 0; p < this.form.lessorInfoBoList.length; p++) {
        if (!this.form.lessorInfoBoList[p].lessorsType) {
          this.$message.error('业主类型不能为空');
          return;
        }
      }

      if (this.form.lessorInfoBoList.length === 0) {
        this.$message.error('至少填写一位联系人信息');
        return;
      }
      // if (arr.length === 0) {
      //   this.$message.error('至少填写一位业主信息')
      //   return
      // }
      if (this.typeArr.length >= 3) {
        this.$message.error('最多添加两位业主信息');
        return;
      }
      // if (transArr.length === 0) {
      //   this.$message.error('至少填写一位转让方')
      //   return
      // }
      if (this.transferorArr.length >= 2) {
        this.$message.error('最多添加一位转让方');
        return;
      }
      if (this.twoRoomArr.length >= 2) {
        this.$message.error('最多添加一位二房东');
        return;
      }
      if (this.agentArr.length >= 2) {
        this.$message.error('最多添加一位代理人');
        return;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.refer();
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },

    buttonItemLayout() {
      const { layout } = this.form;
      return layout === 'horizontal'
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    },

    goList() {
      this.$store.dispatch('tagsView/delCachedView', 'HousesAdd');
      this.$route.meta.position = { x: 0, y: 0 };
      this.$router.go(-1);
    },
    // 新增房源
    addhouse() {
      this.form.channelResource = '1';
      this.form.houseBrokerage = (this.form.houseBrokerage * 1).toFixed(2);
      houseApi.houseInfo({ ...this.form }).then((res) => {
        if (res.code === 200) {
          this.$message.success('新增房源信息成功');
          this.saveType = true;
          this.isBanbetsu = false;
          this.goList();
        }
      });
    },
    // 编辑房源
    edithouse() {
      this.form.channelResource = '1';
      this.form.houseBrokerage = (this.form.houseBrokerage * 1).toFixed(2);
      houseApi.editHouseInfo({ ...this.form }).then((res) => {
        if (res.code === 200) {
          this.saveType = true;
          this.$message.success('修改房源信息成功');
          this.goList();
        }
      });
    },
    // 查询房源自定义标签列表
    getCusTag() {
      houseApi.GethouseCustomTag({ tagName: '', rentSaleType: this.rentSaleType }).then((res) => {
        if (res.code === 200) {
          this.CusListData = res.data;
        }
      });
    },
    // 自定义标签change事件
    cusLabel(val) {
      this.addCusData = val;
    },
    // 租金
    rent() {
      this.form.rentFeeCentiare = parseFloat(this.form.rentFee / this.form.grossFloorArea).toFixed(2);
      if (this.form.grossFloorArea) {
        this.form.rentFeeCentiare = parseFloat(this.form.rentFee / this.form.grossFloorArea).toFixed(2);
      }
    },
    // 租金单价改变
    priceChange(e) {
      const value = (this.form.rentFee / this.form.grossFloorArea).toFixed(2) + '';
      if (this.price == value) {
        return;
      }
      this.form.rentFee = (e.target.value * this.form.grossFloorArea).toFixed(2) + '';
    },
    // 提交
    refer() {
      this.form.paymentMethod = 'Y' + this.paymentMethod1 + 'F' + this.paymentMethod2;
      if (this.addoredit === 0) {
        let isSave;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            isSave = true;
          } else {
            isSave = false;
          }
        });
        if (this.form.isCatering === 'Y' && !this.form.alloweCateringTypeId) {
          this.$message.warning('请选择餐饮状态');
          return;
        }
        if (!isSave) {
          this.$message.warning('请填写完整');
          return;
        }

        //  处理是否临街数据（0为true,1为false）
        if (this.form.isFrontage === 0) {
          this.form.isFrontage = 'Y';
        } else {
          this.form.isFrontage = 'N';
        }
        this.isBanbetsu = true;
      } else {
        this.form.paymentMethod = 'Y' + this.paymentMethod1 + 'F' + this.paymentMethod2;
        this.edithouse();
      }
    },
    addChange(a) {
      a.forEach((item) => {
        this.form[item] = 'Y';
      });
    },
    // 查询房源是否存在
    getSearchHouseMsg() {
      console.log(this.form, 'parmars');
      const { districtName, businessDistrictName, streetName } = this.form;
      const { districtId, businessDistrictId, streetId, houseNumber, houseNumberDeputy } = this.form;

      if (districtName && businessDistrictId && streetId && houseNumber && houseNumberDeputy) {
        const parmars = {};
        parmars.districtId = districtId;
        parmars.businessDistrictId = businessDistrictId;
        parmars.streetId = streetId;
        parmars.houseNumber = houseNumber;
        parmars.houseNumberDeputy = houseNumberDeputy;
        if (this.houseId) {
          parmars.id = this.houseId;
        }

        houseApi.searchHouseMsg(parmars).then((res) => {
          if (res.code === 200) {
            if (res.data.isExists) {
              // isExists为true 房源信息存在  不能再次提交
              this.isExists = res.data.isExists;
              this.detailsId = res.data.houseInfoId;
              this.houseCode = res.data?.houseCode || undefined;
              this.$message.warning('该房源信息已经存在');
              this.visibleDetials = true;
            } else {
              this.isExists = res.data.isExists;
              this.$message.success('新房源!');
            }
          }
        });
      }
    },
    // 存在房源跳转
    handleDetails() {
      this.visibleDetials = false;
      this.$router.push({
        path: '/houses/detail/index',
        query: {
          id: this.detailsId,
          formTitle: '出租详情'
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  },
  watch: {
    'form.houseFloorType': {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.form.houseFloor = '';
        }
      }
    },
    'form.grossFloorArea': {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.is_input_rentFee = false;
        } else {
          this.is_input_rentFee = true;
        }
      }
    },
    'form.industrySubclassJsonId': {
      handler: function (newVal, oldVal) {
        // 父类匹配子类 解决子类删除父类id不删除问题
        const data = this.industrySubJsonList.filter((item) => newVal.includes(item.id + ''));
        const fatherChilds = this.newArrFn(data.map((item) => item.parentId + ''));
        const obj = {};
        fatherChilds.forEach((item) => {
          const arr = [];
          data.forEach((el) => {
            if (item == el.parentId + '') {
              arr.push(el.id);
              obj[item] = arr.join(',');
            }
          });
        });
        this.form.industryCategoryJsonKeyValueId = obj;
        if (this.isWatch) {
          this.form.industryCategoryJsonId = fatherChilds;
          console.log(fatherChilds, 'fatherChilds');
        } else {
          this.isWatch = true;
        }
      }
    },
    deep: true
  }
};
</script>

<style>
.dwyText {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  position: relative;
}

.dwybs::before {
  display: inline-block;
  margin-right: 4px;
  color: #ffc400;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}

.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
</style>
<style lang="less" scoped>
.w120 {
  width: 120px;
}

.ml20 {
  margin-left: 20px;
}

.ml10 {
  margin-left: 10px;
}

.add {
  width: 100%;
  // height: 400px;
  // background-color: rgb(107, 3, 3);
  background-color: white;

  labelCol {
    width: 150px;
  }

  .add-center {
    width: 95%;
    margin: 0 auto;

    header {
      height: 80px;
      display: flex;
      align-items: center;

      & > p {
        margin-bottom: 0;
        font-size: 26px;
        font-weight: bold;
        color: black;
      }

      & > img {
        // flex-shrink: 1;
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-top: 3px;
      }
    }

    aside {
      .main {
        width: 94%;
        // height: 100px;
        // background-color: aqua;
        margin: 0 auto;
        background-color: white;

        & > .main-form {
          width: 100%;
          margin: 0px auto 0;
          /* margin: 30px auto 0; */

          /deep/ p {
            font-size: 24px;

            color: black;
          }

          /deep/ .ant-col-4 {
            width: 21.666667%;
            text-align: left;
          }

          /deep/ .ant-col-10 {
            width: 29.666667%;
          }

          /deep/ .ant-form-item {
            display: flex;
            flex-direction: column;
          }

          /deep/ .addInfor {
            margin-top: 42px;
          }

          .hr {
            width: 100%;
            height: 1px;
            border: 1px solid #f2f6fc;
            margin-top: 10px;
            margin-bottom: 20px;
          }

          /deep/ .ant-col-12 {
            width: 25%;
          }

          #basicStore {
            list-style: none;
            display: flex;
            justify-content: space-between;
            width: 64%;
            margin-left: -41px;
          }

          #current {
            list-style: none;
            display: flex;
            width: 65.4%;
            justify-content: space-between;
            margin-left: -41px;

            /deep/ li {
              width: 200px;
            }
          }

          .bacisInfo {
            width: 80%;
            list-style: none;
            display: flex;
            justify-content: space-between;
            margin-left: -41px;
          }

          .checkrow {
            /deep/ ul {
              list-style: none;

              li {
                label {
                  margin-right: 10px;
                }

                .input_val {
                  width: 60px;
                  border: 1px solid #d9d9d9;
                  outline: none;
                  height: 16px;
                  margin-right: 20px;
                }
              }
            }
          }

          /deep/ #priceInfor {
            width: 65%;
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-left: -41px;

            & > li {
              margin-right: 10px;
            }
          }

          /deep/ #paymethod {
            width: 68%;
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-left: -41px;
          }

          /deep/ #commfee {
            list-style: none;
            display: flex;
            justify-content: space-between;
            width: 37%;
            margin-left: -41px;
          }

          /deep/ .submit {
            width: 80px;
            height: 35px;
            border-radius: 5px;
            font-size: 15px;
            text-align: center;
            line-height: 35px;
            background-color: var(--ThemeColor);
          }
        }
      }
    }
  }
}

.search-btn {
  width: 60px;
  margin-left: 20px;
}

.submit-btns {
  padding-top: 30px;

  /deep/ .ant-col-18 {
    width: 100% !important;
  }
}

.mg-l-10 {
  margin-left: 10px;
}
</style>
